import axiosInstance from "../../../services/config/axiosinstance";
import { urlBaseAccreditation } from './../../config/index';
import ZebraTagModel from './../../../models/ZebraTagModel';

export default async function getTags() {
  try {
    const _config = {
      url: `${urlBaseAccreditation}/zebraTagCode/getZebraTagCodes?limit=1000`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };
    const _ret = await axiosInstance(_config);

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    const _return = [];

    for (let i = 0; i < _ret.data.data.data.length; i++) {
      _return.push(ZebraTagModel(_ret.data.data.data[i]));
    }

    return _return;
  } catch (error) {
    console.log('Error getTags', error);
    throw error;
  }
}
